import { BUSINESS_TYPE } from "@faire/deprecated-retailer-visitor-shared/consts/BUSINESS_TYPE";
import { useRetailer } from "@faire/deprecated-retailer-visitor-shared/hooks/retailer/useRetailer";
import { getSettingOpenWithFaireAvailableForCountry } from "@faire/deprecated-retailer-visitor-shared/settings/getSettingOpenWithFaireAvailableForCountry";
import { IRetailer } from "@faire/web-api--source/indigofair/data/IRetailer";
import { useCallback } from "react";

const BUSINESS_TYPE_TO_CATEGORY = (businessType: BUSINESS_TYPE) => {
  switch (businessType) {
    case BUSINESS_TYPE.POP_UP_STORE:
      return IRetailer.BusinessCategory.POP_UP;
    case BUSINESS_TYPE.ONLINE_ONLY:
      return IRetailer.BusinessCategory.ONLINE_ONLY;
    case BUSINESS_TYPE.BRICK_AND_MORTAR_SHOP:
      return IRetailer.BusinessCategory.BRICK_AND_MORTAR;
    case BUSINESS_TYPE.OTHER:
      return IRetailer.BusinessCategory.BUSINESS_OTHER;
    case BUSINESS_TYPE.CONSUMER:
    default:
      return undefined;
  }
};
export const useOpenWithFaireRetailerStatus = () => {
  const { retailer } = useRetailer();

  /**
   * Returns true if retailer can be referred for credit. Achieved by clicking a referral link sent by another retailer
   */
  const canBeReferred = useCallback(
    (retailerBusinessType?: BUSINESS_TYPE) => {
      let retailerBusinessCategory = retailer?.business_category;
      if (!retailerBusinessCategory && retailerBusinessType) {
        retailerBusinessCategory =
          BUSINESS_TYPE_TO_CATEGORY(retailerBusinessType);
      }

      if (retailerBusinessCategory === undefined) {
        return false;
      }

      return getSettingOpenWithFaireAvailableForCountry();
    },
    [retailer?.business_category]
  );

  return {
    isRetailerStartedThisYear:
      retailer?.reported_creation_time ===
      IRetailer.ReportedCreationTime.STARTED_THIS_YEAR,
    canBeReferred,
  };
};
